import {isMatchMedia} from '%helpers%/utils';
import {
  showWidgetError,
  hideWidgetError,
  hideLoading,
  showLoading,
  initTomSelect,
  initTomMultiCheckboxSelect,
  initInputMaskByKey,
  initIntlTelInput,
  initInputMask,
} from '%helpers%/helpers';
import wNumb from 'wnumb';
import {first} from 'lodash';

export const initiateUmbracoFormRate = widget => {
  if (!widget) return;

  const form = widget.querySelector('form');
  if (!form) return;
  form.querySelectorAll('.google-autocomplete').forEach(async el => {
    await initGoogleAutocompleteUmbracoForms(el);
  });
  const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  let activeStep = 0;
  let suppressSetEvent = false;
  let avoidPrefill = false;
  const recordInput = document.querySelector('input[name="RecordId"]');
  const hasRecordId =
    recordInput && recordInput.value && recordInput.value !== '00000000-0000-0000-0000-000000000000';
  let sliderEl = widget.querySelector('.js-range-slider');
  const noResults = widget.querySelector('.products-no-results');
  const cards = form.querySelectorAll(`[data-scenario]`);

  const formatter = wNumb({
    decimals: 0,
    thousand: ',',
    prefix: '$',
  });

  widget.addEventListener('click', e => {
    const target = e.target.closest('[name=__prev]');
    if (target) {
      e.preventDefault();
      const form = target.closest('form');
      window.clickedButton = 'prev';
      form.requestSubmit();
      target.dispatchEvent(new Event('form-back', {bubbles: true}));
      target.disabled = true;
    }
  });

  widget.addEventListener('click', e => {
    const target = e.target.closest('[name=__next]');
    if (target) {
      e.preventDefault();
      const form = target.closest('form');
      window.clickedButton = 'primary';
      form.requestSubmit();
      target.disabled = true;
    }
  });

  form.addEventListener('submit', async e => {
    e.preventDefault();
    try {
      showLoading();
      hideWidgetError();
      const currentNodePageUrl = document.querySelector('#pageInfoDiv')?.dataset.url;
      const umbracoFormsForm = form.closest('.umbraco-forms-form');
      const widgetFormContent = form.closest('.widget-form-content');
      const formId = umbracoFormsForm?.id;
      const formData = new FormData(form);
      const isPreviousClicked = window.clickedButton === 'prev';
      if (isPreviousClicked) {
        formData.append('__prev', 'Previous');
      }
      window.clickedButton = '';

      let sessionStorageRecordId = sessionStorage.getItem('UmbracoFormsRecordId');
      if (form.checkValidity()) {
        form.dataset.submitted = 'true';
        form.querySelectorAll('input[data-mask]').forEach(input => {
          input.blur();
        });
        let url = form.action;
        if (sessionStorageRecordId && sessionStorageRecordId !== '00000000-0000-0000-0000-000000000000') {
          url += `?recordId=${sessionStorageRecordId}`;
          form.querySelector('input[name="RecordId"]').value = sessionStorageRecordId;
        }

        const response = await fetch(url, {
          method: 'POST',
          body: formData,
        });
        const html = await response.text();

        const parser = new DOMParser();
        const resultDoc = parser.parseFromString(html, 'text/html');

        let thankYouMessage =
          resultDoc.querySelector('.umbraco-forms-submitmessage') ||
          resultDoc.querySelector('.umbraco-forms-submitmessage-html');
        let formRecordId = resultDoc.querySelector('.formRecordId')?.getAttribute('data-record-id') || null;

        const errors = resultDoc.querySelectorAll(`#${formId} .field-validation-error`);
        const submitLastPage = form.querySelector('.multipage-lastpage');
        const resultNodePageUrl = resultDoc.querySelector('#pageInfoDiv')?.dataset.url;
        const resultStep = resultDoc.querySelector(`#${formId} input[name="FormStep"]`)?.value;
        const currentStep = form.querySelector('input[name="FormStep"]')?.value;
        const recordState = resultDoc.querySelector(`#${formId} input[name="RecordState"]`)?.value;
        const token = resultDoc.querySelector(`#${formId} input[name="__RequestVerificationToken"]`)?.value;
        const ufprt = resultDoc.querySelector(`#${formId} input[name="ufprt"]`)?.value;
        const id = resultDoc.querySelector('.umbraco-forms-page')?.id;

        if (resultStep) {
          form.querySelector('input[name="FormStep"]').value = resultStep;
          activeStep = Number(resultStep);
        }
        if (recordState) form.querySelector('input[name="RecordState"]').value = recordState;
        if (token) form.querySelector('input[name="__RequestVerificationToken"]').value = token;
        if (ufprt) form.querySelector('input[name="ufprt"]').value = ufprt;
        if (id) form.querySelector('.umbraco-forms-page').id = id;

        if (isPreviousClicked) {
          form.dataset.submitted = '';
          const visible = getVisibleElement('.umbraco-forms-custom-class', form);
          if (visible) visible.remove();

          const replacement = resultDoc.querySelector(`#${formId} form .umbraco-forms-custom-class`);

          if (replacement) {
            const target = form.querySelector(`.umbraco-forms-custom-class[data-step="${resultStep}"]`);
            if (target) {
              target.style.display = 'block';
              target.innerHTML = replacement.innerHTML;

              initiateFormElements(target);
              avoidPrefill = true;
            }
          }
        } else if (errors.length > 0) {
          form.dataset.submitted = '';

          const replacement = resultDoc.querySelector(`#${formId} form .umbraco-forms-custom-class`);

          if (replacement) {
            const visible = getVisibleElement('.umbraco-forms-custom-class', form);
            if (visible) {
              visible.innerHTML = replacement.innerHTML;
              initiateFormElements(visible);
            }
          }
        } else if (resultNodePageUrl && resultNodePageUrl !== currentNodePageUrl) {
          form.dataset.submitted = 'true';
          window.location.href = resultNodePageUrl;
        } else if (thankYouMessage) {
          if (!sessionStorageRecordId && formRecordId) {
            sessionStorage.setItem('UmbracoFormsRecordId', formRecordId);
          }
          setFormDataSessionStorage(formData);
          const data = await fetchData(true);
          initLoanAmountSlider(data);
          updateContactCard(data);
          updateLoanCards(JSON.parse(data.result));
          syncSteps(currentStep, activeStep, false, true);
          avoidPrefill = true;
        } else if (submitLastPage) {
          if (!sessionStorageRecordId && formRecordId) {
            sessionStorage.setItem('UmbracoFormsRecordId', formRecordId);
          }
          setFormDataSessionStorage(formData);
          const data = await fetchData(true);
          initLoanAmountSlider(data);
          updateContactCard(data);
          updateLoanCards(JSON.parse(data.result));
          avoidPrefill = true;
        } else {
          form.dataset.submitted = '';
          form.querySelectorAll('.umbraco-forms-custom-class').forEach(el => (el.style.display = 'none'));
          const replacement = resultDoc.querySelector(`#${formId} form .umbraco-forms-custom-class`);
          if (replacement) {
            initiateFormElements(replacement);
            replacement.classList.add('page-' + currentStep);
            form.querySelector('.umbraco-forms-page').appendChild(replacement);
            prefillForm();
          }
          syncSteps(currentStep, activeStep);
        }
        window.UmbracoForms.reinitConditions(widgetFormContent);
      }
      form.dispatchEvent(new Event('formSubmissionEnded'));
    } catch (error) {
      console.error('Error fetching loan options:', error);
    } finally {
      hideLoading();
      form.querySelectorAll('.buttons-block input').forEach(el => (el.disabled = false));
    }
  });

  function prefillForm() {
    const savedData = sessionStorage.getItem('formData');
    if (!savedData || avoidPrefill || hasRecordId) return;

    const dataObj = JSON.parse(savedData);

    Object.entries(dataObj).forEach(([key, value]) => {
      if (!guidRegex.test(key)) return;

      const inputs = form.querySelectorAll(`[name="${key}"]`);
      if (!inputs || !value) return;

      inputs.forEach(el => {
        const type = el.type;

        if (type === 'checkbox') {
          if (Array.isArray(value)) {
            el.checked = value.includes(el.value);
          } else {
            el.checked = el.value === value;
          }
        } else if (type === 'radio') {
          el.checked = el.value === value;

          if (el.checked) {
            el.dispatchEvent(new Event('change', {bubbles: true}));
          }
        } else if (el.tagName.toLowerCase() === 'select') {
          const ts = el.tomselect;

          if (Array.isArray(value)) {
            ts.setValue(value, true); // silent
          } else {
            ts.setValue(value, true);
          }
          return;
        } else {
          el.value = value;
        }
      });
    });
  }

  function setFormDataSessionStorage(formData) {
    const dataObj = {};

    formData.forEach((value, key) => {
      if (!value) return;
      if (!guidRegex.test(key)) return;

      const input = form.querySelector(`[name="${key}"]`);
      if (input?.type === 'checkbox') {
        if (!dataObj[key]) dataObj[key] = [];
        dataObj[key].push(value);
      } else {
        dataObj[key] = value;
      }
    });

    sessionStorage.setItem('formData', JSON.stringify(dataObj));
  }

  function waitForFormToFinish(form) {
    return new Promise(resolve => {
      form.addEventListener('formSubmissionEnded', () => resolve(), {once: true});
    });
  }

  function getVisibleElement(selector, root = document) {
    const elements = root.querySelectorAll(selector);
    return Array.from(elements).find(el => el.offsetParent !== null) || null;
  }

  function initiateFormElements(selector) {
    if (selector) {
      selector
        .querySelectorAll('input[data-mask]:not(.js-input), input[data-mask]:not(.cash-amount)')
        .forEach(el => {
          initInputMaskByKey(el, el.getAttribute('data-mask'));
        });

      selector.querySelectorAll('input.cash-amount').forEach(el => {
        const fieldsJson = el.getAttribute('data-mapped-fields');
        if (!fieldsJson) return;

        const form = el.closest('form');
        let mappedFields = [];

        try {
          mappedFields = JSON.parse(fieldsJson);
        } catch {
          return;
        }

        let propertyValueInput = null;
        let firstMortgageInput = null;

        mappedFields.forEach(field => {
          const target = form.querySelector(`input[name="${field.value}"], select[name="${field.value}"]`);
          if (!target) return;

          switch (field.alias) {
            case 'propertyValue':
              propertyValueInput = target;
              break;
            case 'firstMortagage':
              firstMortgageInput = target;
              break;
          }
        });

        const initialMax = calculateMax(propertyValueInput?.value, firstMortgageInput?.value);

        const settings = {
          alias: 'numeric',
          min: 25000,
          max: initialMax,
          digits: 0,
          autoGroup: true,
          rightAlign: false,
          allowMinus: false,
          placeholder: '',
          groupSeparator: ',',
          radixPoint: '.',
        };

        const maskInstance = initInputMask(el, settings);

        const recalc = () => {
          const newMax = calculateMax(propertyValueInput?.value, firstMortgageInput?.value);

          updateInputMaskMax(el, maskInstance, newMax);
        };

        propertyValueInput?.addEventListener('input', recalc);
        firstMortgageInput?.addEventListener('input', recalc);
      });

      selector.querySelectorAll('select.js-select').forEach(el => {
        if (el.multiple) initTomMultiCheckboxSelect(el);
        else initTomSelect(el);
      });

      selector.querySelectorAll('.js-intlTel').forEach(input => {
        initIntlTelInput(input);
      });

      selector.querySelectorAll('.google-autocomplete').forEach(async el => {
        await initGoogleAutocompleteUmbracoForms(el);
      });

      function calculateMax(propertyValue, firstMortgage) {
        const pv = getNumericValue(propertyValue);
        const fm = getNumericValue(firstMortgage);

        if (!pv && !fm) return 500000;

        const ninetyPercent = pv * 0.9 - fm;
        return Math.min(Math.max(ninetyPercent, 0), 500000);
      }

      function updateInputMaskMax(input, maskInstance, newMax) {
        if (!maskInstance) return;

        maskInstance.option({max: newMax});
        maskInstance.remove();
        maskInstance.mask(input);
        const rawValue = input.inputmask?.unmaskedvalue?.();
        const numericValue = Number(rawValue) || 0;

        if (numericValue > newMax) {
          input.value = newMax;
          input.dispatchEvent(new Event('input', {bubbles: true}));
        }
      }

      function getNumericValue(valueOrInput) {
        if (valueOrInput?.inputmask) {
          return Number(valueOrInput.inputmask.unmaskedvalue()) || 0;
        }

        if (typeof valueOrInput === 'string') {
          return Number(valueOrInput.replace(/[.,\s]/g, '')) || 0;
        }

        return Number(valueOrInput) || 0;
      }
    }
  }

  async function initGoogleAutocompleteUmbracoForms(el) {
    if (!el) return;
    const fieldsJson = el.getAttribute('data-mapped-fields');

    if (fieldsJson) {
      const {Autocomplete} = await google.maps.importLibrary('places');

      const autocomplete = new Autocomplete(el, {
        fields: ['address_components'],
        types: ['address'],
        componentRestrictions: {country: ['us']},
      });

      // Mapping fields from Umbraco
      const form = el.closest('form');
      let mappedFields = [];

      if (fieldsJson) {
        try {
          mappedFields = JSON.parse(fieldsJson);
        } catch {
          mappedFields = [];
        }
      }

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place || !place.address_components) return;

        const components = {};
        for (const comp of place.address_components) {
          if (comp.types.includes('street_number')) components.street = comp.long_name;
          if (comp.types.includes('route')) components.route = comp.long_name;
          if (comp.types.includes('locality')) components.city = comp.long_name;
          if (comp.types.includes('administrative_area_level_1')) {
            components.state = comp.long_name;
            components.stateValue = comp.short_name;
          }
          if (comp.types.includes('country')) components.country = comp.long_name;
          if (comp.types.includes('postal_code')) components.postcode = comp.long_name;
          if (comp.types.includes('administrative_area_level_2')) components.county = comp.long_name;
        }

        const street = (components.street ? components.street + ' ' : '') + (components.route || '');

        mappedFields.forEach(field => {
          const target = form.querySelector(`input[name="${field.value}"], select[name="${field.value}"]`);
          if (!target) return;

          switch (field.alias) {
            case 'Street Address':
              target.value = street;
              break;
            case 'Country':
              target.value = components.country || '';
              break;
            case 'County':
              target.value = components.county?.replace(/ county$/i, '') || '';
              break;
            case 'State':
              if (target.tagName.toLowerCase() === 'select') {
                const ts = target.tomselect;

                if (Array.isArray(target.value)) {
                  ts.setValue(components.stateValue || '', true);
                } else {
                  ts.setValue(components.stateValue || '', true);
                }
                return;
              } else {
                target.value = components.state || '';
              }
              break;
            case 'City':
              target.value = components.city || '';
              break;
            case 'Zip Code':
              target.value = components.postcode || '';
              break;
          }
        });
      });
    }
  }

  function syncSteps(currentStep, nextStep, error = false, lastStep = false) {
    const lastBtn = widget.querySelector('.to-last-page');
    const currentTab = widget.querySelector(`[data-bs-toggle="tab"][data-step="${currentStep}"]`);
    const nextTab = widget.querySelector(`[data-bs-toggle="tab"][data-step="${nextStep}"]`);
    if (lastStep && lastBtn) {
      if (currentTab) {
        currentTab.disabled = false;
        currentTab.classList.add('completed');
      }
      lastBtn.disabled = false;
      lastBtn.classList.add('completed');
      bootstrap.Tab.getOrCreateInstance(lastBtn).show();
    } else if (error) {
    } else {
      if (currentTab) {
        currentTab.disabled = false;
        currentTab.classList.add('completed');
      }
      if (nextTab) {
        bootstrap.Tab.getOrCreateInstance(nextTab).show();
      }
    }
  }

  const fetchData = async (resetLoanAmount = false) => {
    const formData = new FormData(form);
    if (resetLoanAmount) formData.set('loanAmount', '0');
    const data = Object.fromEntries(formData.entries());

    try {
      const response = await fetch('/umbraco/surface/loanapi/GetLoanOptionsTask', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error(`API error: ${response.status}`);

      const result = await response.json();

      document.querySelector('.request').innerHTML =
        `<pre>REQUEST${JSON.stringify(result.request, null, 2)}</pre>`;
      document.querySelector('.response').innerHTML =
        `<pre>RESPONSE${JSON.stringify(JSON.parse(result.result), null, 2)}</pre>`;
      return result;
    } catch (error) {
      showWidgetError(
        widget.querySelector('.tab-content'),
        'An error occurred while fetching data. Please try again later.'
      );
      cards.forEach(card => {
        card.classList.add('d-none');
      });
      noResults.classList.remove('d-none');
      console.error('Error fetching loan options:', error);
      return null;
    }
  };

  widget.querySelectorAll('[data-bs-toggle="tab"]').forEach(btn => {
    btn.addEventListener('click', async e => {
      if (btn.classList.contains('to-last-page')) return;
      let {step} = btn.dataset;
      let currentStep = form.querySelector('input[name="FormStep"]')?.value;
      step = Number(step);
      currentStep = Number(currentStep);
      if (Number.isNaN(step) || Number.isNaN(currentStep)) return;

      if (step > currentStep) {
        const stepsToAdvance = step - currentStep;
        for (let i = 0; i < stepsToAdvance; i++) {
          const nextButton = form.querySelector('input[name="__next"]');
          if (nextButton) {
            nextButton.disabled = false;
            nextButton.click();
            await waitForFormToFinish(form);
          } else {
            console.warn('Next button not found — cannot move forward');
            break;
          }
        }
      } else if (currentStep > step) {
        const stepsToGoBack = currentStep - step;
        for (let i = 0; i < stepsToGoBack; i++) {
          const backButton = form.querySelector('input[name="__prev"]');
          if (backButton) {
            backButton.disabled = false;
            backButton.click();
            await waitForFormToFinish(form);
          } else {
            break;
          }
        }
      }
      hideWidgetError();
    });
  });

  widget.querySelectorAll('[data-action="changeStep"]').forEach(btn => {
    btn.addEventListener('click', e => {
      let {step} = btn.dataset;
      const btnTab = widget.querySelector(`[data-step="${step}"][data-bs-toggle="tab"]`);

      if (btnTab) btnTab.click();
    });
  });

  function initLoanAmountSlider(data) {
    if (!data.request) return;

    let loanAmount = data.request.loanAmount;
    let propertyValue = data.request.propertyValue;
    let firstMortagage = data.request.firstMortgageBalance;
    let maxAmount = propertyValue * 0.9 - firstMortagage || 0;
    if (maxAmount > 500000) maxAmount = 500000;
    if (loanAmount && maxAmount) {
      if (sliderEl) {
        const wrapper = sliderEl.closest('.range-wrapper');
        if (!wrapper) return;
        const input = wrapper.querySelector('.range-control');
        const inputFormat = wrapper.querySelector('.range-format');
        const rangeMax = wrapper.querySelector('.range-max');
        if (rangeMax) rangeMax.textContent = formatter.to(maxAmount);
        if (inputFormat) inputFormat.value = loanAmount;
        if (input) {
          input.value = loanAmount;
          input.max = maxAmount;
        }
        suppressSetEvent = true;
        if (!sliderEl.noUiSlider) {
        } else {
          sliderEl.noUiSlider.updateOptions({
            range: {
              min: 25000,
              max: maxAmount,
            },
          });
        }
        sliderEl.noUiSlider.set(loanAmount);
        suppressSetEvent = false;
      }
    }
  }
  function updateLoanCards(data) {
    if (!data) return;
    const hasAnyProducts = data.some(option => option?.eligible?.products?.length > 0);
    if (hasAnyProducts) {
      noResults.classList.add('d-none');
      data.forEach(option => {
        const scenario = option.scenario;
        const card = widget.querySelector(`[data-scenario="${scenario}"]`);
        if (!card) return;
        card.classList.remove('d-none');
        if (scenario === 'FIXED_HELOC') {
          const eligible = option.eligible || {};
          const products = eligible.products || [];
          if (!products.length) {
            card.classList.add('d-none');
            return;
          }
          let productThirtyYear = null;
          let productTwentyYear = null;
          let productFifteenYear = null;
          products.forEach(product => {
            if (
              product.amortizationTerm.includes('FifteenYear') &&
              product.productName.includes('Standalone')
            ) {
              productFifteenYear = product;
            } else if (
              product.amortizationTerm.includes('TwentyYear') &&
              product.productName.includes('Standalone')
            ) {
              productTwentyYear = product;
            } else if (
              product.amortizationTerm.includes('ThirtyYear') &&
              product.productName.includes('Standalone')
            ) {
              productThirtyYear = product;
            }
          });
          const totalLoanAmount = eligible.totalLoanAmountDetails?.totalLoanAmount ?? null;
          // Draw Amount
          const drawWrapper = card.querySelector('[data-draw-container]');
          const termWrapper = card.querySelector('[data-term-container]');
          const years = termWrapper.querySelectorAll('input[type="radio"]');

          years.forEach(year => {
            let monthlyValue;
            let parts = [];
            if (year.value == '30') {
              const config = {
                lineAmount: totalLoanAmount,
                annualRate: productThirtyYear.rate,
                drawAmount: totalLoanAmount,
                termYears: 30,
              };
              monthlyValue =
                productThirtyYear?.principalAndInterest ||
                calculateLoanProduct(scenario, config).monthlyPayment;
              parts = [];
              if (productThirtyYear.rate) parts.push(`Rate: <strong>${productThirtyYear.rate}%</strong>`);
              if (productThirtyYear.apr) parts.push(`APR: <strong>${productThirtyYear.apr}%</strong>`);
            } else if (year.value == '20') {
              let rate = productTwentyYear?.rate || productThirtyYear.rate;
              let apr = productTwentyYear?.apr || productThirtyYear.apr;
              const config = {
                lineAmount: totalLoanAmount,
                annualRate: rate,
                drawAmount: totalLoanAmount,
                termYears: 20,
              };
              monthlyValue =
                productTwentyYear?.principalAndInterest ||
                calculateLoanProduct(scenario, config).monthlyPayment;
              parts = [];
              if (rate)
                parts.push(
                  `Rate: <strong>${rate.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
              if (apr)
                parts.push(
                  `APR: <strong>${apr.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
            } else if (year.value == '15') {
              let rate = productFifteenYear?.rate || productTwentyYear?.rate || productThirtyYear.rate;
              let apr = productFifteenYear?.apr || productTwentyYear?.apr || productThirtyYear.apr;
              const config = {
                lineAmount: totalLoanAmount,
                annualRate: rate,
                drawAmount: totalLoanAmount,
                termYears: 15,
              };
              monthlyValue =
                productFifteenYear?.principalAndInterest ||
                calculateLoanProduct(scenario, config).monthlyPayment;
              parts = [];
              if (rate)
                parts.push(
                  `Rate: <strong>${rate.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
              if (apr)
                parts.push(
                  `APR: <strong>${apr.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
            } else {
              let rate = productTwentyYear?.rate || productThirtyYear.rate;
              let apr = productTwentyYear?.apr || productThirtyYear.apr;
              const config = {
                lineAmount: totalLoanAmount,
                annualRate: rate,
                drawAmount: totalLoanAmount,
                termYears: Number(year.value),
              };
              monthlyValue = calculateLoanProduct(scenario, config).monthlyPayment;
              parts = [];
              if (rate)
                parts.push(
                  `Rate: <strong>${rate.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
              if (apr)
                parts.push(
                  `APR: <strong>${apr.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
            }
            const paymentEl = card.querySelector(`[data-term="${year.value}"][data-field="monthly-payment"]`);
            if (paymentEl) {
              paymentEl.textContent =
                monthlyValue && monthlyValue > 0
                  ? `$${monthlyValue.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
                  : '-';
            }
            const subtextEl = card.querySelector(`[data-value="${year.value}"][data-field="subtext"]`);
            if (subtextEl) {
              subtextEl.innerHTML = parts.length ? parts.join(' | ') : 'Details not available';
            }
          });

          const dataDrawn = drawWrapper.querySelector('.min-draw-amount');

          if (dataDrawn) {
            dataDrawn.textContent = `$${totalLoanAmount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
          }
        } else if (scenario === 'HELOAN') {
          const eligible = option.eligible || {};
          const products = eligible.products || [];
          if (!products.length) {
            card.classList.add('d-none');
            return;
          }
          let productThirtyYear = null;
          let productTwentyYear = null;
          let productFifteenYear = null;
          products.forEach(product => {
            if (
              product.amortizationTerm.includes('FifteenYear') &&
              product.productName.includes('Standalone')
            ) {
              productFifteenYear = product;
            } else if (
              product.amortizationTerm.includes('TwentyYear') &&
              product.productName.includes('Standalone')
            ) {
              productTwentyYear = product;
            } else if (
              product.amortizationTerm.includes('ThirtyYear') &&
              product.productName.includes('Standalone')
            ) {
              productThirtyYear = product;
            }
          });
          const totalLoanAmount = eligible.totalLoanAmountDetails?.totalLoanAmount ?? null;
          const termWrapper = card.querySelector('[data-term-container]');
          const years = termWrapper.querySelectorAll('input[type="radio"]');

          years.forEach(year => {
            let monthlyValue;
            let parts = [];
            if (year.value == '30') {
              const config = {
                principal: totalLoanAmount,
                annualRate: productThirtyYear.rate,
                termYears: 30,
              };
              monthlyValue =
                productThirtyYear?.principalAndInterest ||
                calculateLoanProduct(scenario, config).monthlyPayment;
              parts = [];
              if (productThirtyYear.rate)
                parts.push(
                  `Rate: <strong>${productThirtyYear.rate.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
              if (productThirtyYear.apr)
                parts.push(
                  `APR: <strong>${productThirtyYear.apr.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
            } else if (year.value == '20') {
              let rate = productTwentyYear?.rate || productThirtyYear.rate;
              let apr = productTwentyYear?.apr || productThirtyYear.apr;
              const config = {
                principal: totalLoanAmount,
                annualRate: rate,
                termYears: 20,
              };
              monthlyValue =
                productTwentyYear?.principalAndInterest ||
                calculateLoanProduct(scenario, config).monthlyPayment;
              parts = [];
              if (rate)
                parts.push(
                  `Rate: <strong>${rate.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
              if (apr)
                parts.push(
                  `APR: <strong>${apr.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
            } else if (year.value == '15') {
              let rate = productFifteenYear?.rate || productTwentyYear?.rate || productThirtyYear.rate;
              let apr = productFifteenYear?.apr || productTwentyYear?.apr || productThirtyYear.apr;
              const config = {
                principal: totalLoanAmount,
                annualRate: rate,
                termYears: 15,
              };
              monthlyValue =
                productFifteenYear?.principalAndInterest ||
                calculateLoanProduct(scenario, config).monthlyPayment;
              parts = [];
              if (rate)
                parts.push(
                  `Rate: <strong>${rate.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
              if (apr)
                parts.push(
                  `APR: <strong>${apr.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
            } else {
              let rate = productTwentyYear?.rate || productThirtyYear.rate;
              let apr = productTwentyYear?.apr || productThirtyYear.apr;
              const config = {
                principal: totalLoanAmount,
                annualRate: rate,
                termYears: Number(year.value),
              };
              monthlyValue = calculateLoanProduct(scenario, config).monthlyPayment;
              parts = [];
              if (rate)
                parts.push(
                  `Rate: <strong>${rate.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
              if (apr)
                parts.push(
                  `APR: <strong>${apr.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
            }
            const paymentEl = card.querySelector(
              `[data-value="${year.value}"][data-field="monthly-payment"]`
            );
            if (paymentEl) {
              paymentEl.textContent =
                monthlyValue && monthlyValue > 0
                  ? `$${monthlyValue.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
                  : '-';
            }

            const subtextEl = card.querySelector(`[data-value="${year.value}"][data-field="subtext"]`);
            if (subtextEl) {
              subtextEl.innerHTML = parts.length ? parts.join(' | ') : 'Details not available';
            }
          });
        } else if (scenario === 'VARIABLE_HELOC') {
          const eligible = option.eligible || {};
          const products = eligible.products || [];
          if (!products.length) {
            card.classList.add('d-none');
            return;
          }
          let productThirtyYear = null;
          let productTwentyYear = null;
          let productFifteenYear = null;
          products.forEach(product => {
            if (
              product.amortizationTerm.includes('FifteenYear') &&
              product.productName.includes('Standalone')
            ) {
              productFifteenYear = product;
            } else if (
              product.amortizationTerm.includes('TwentyYear') &&
              product.productName.includes('Standalone')
            ) {
              productTwentyYear = product;
            } else if (
              product.amortizationTerm.includes('ThirtyYear') &&
              product.productName.includes('Standalone')
            ) {
              productThirtyYear = product;
            }
          });
          const totalLoanAmount = eligible.totalLoanAmountDetails?.totalLoanAmount ?? null;
          // Draw Amount
          const drawWrapper = card.querySelector('[data-draw-container]');
          const termWrapper = card.querySelector('[data-term-container]');
          const years = termWrapper.querySelectorAll('input[type="radio"]');

          years.forEach(year => {
            let monthlyValue;
            let parts = [];
            if (year.value == '30') {
              const config = {
                lineAmount: totalLoanAmount,
                annualRate: productThirtyYear.rate,
                drawAmount: totalLoanAmount,
                termYears: 30,
              };
              monthlyValue =
                productThirtyYear?.principalAndInterest ||
                calculateLoanProduct('FIXED_HELOC', config).monthlyPayment;
              parts = [];
              if (productThirtyYear.rate)
                parts.push(
                  `Rate: <strong>${productThirtyYear.rate.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
              if (productThirtyYear.apr)
                parts.push(
                  `APR: <strong>${productThirtyYear.apr.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
            } else if (year.value == '20') {
              let rate = productTwentyYear?.rate || productThirtyYear.rate;
              let apr = productTwentyYear?.apr || productThirtyYear.apr;
              const config = {
                lineAmount: totalLoanAmount,
                annualRate: rate,
                drawAmount: totalLoanAmount,
                termYears: 20,
              };
              monthlyValue =
                productTwentyYear?.principalAndInterest ||
                calculateLoanProduct('FIXED_HELOC', config).monthlyPayment;
              parts = [];
              if (rate)
                parts.push(
                  `Rate: <strong>${rate.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
              if (apr)
                parts.push(
                  `APR: <strong>${apr.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
            } else if (year.value == '15') {
              let rate = productFifteenYear?.rate || productTwentyYear?.rate || productThirtyYear.rate;
              let apr = productFifteenYear?.apr || productTwentyYear?.apr || productThirtyYear.apr;
              const config = {
                lineAmount: totalLoanAmount,
                annualRate: rate,
                drawAmount: totalLoanAmount,
                termYears: 15,
              };
              monthlyValue =
                productFifteenYear?.principalAndInterest ||
                calculateLoanProduct('FIXED_HELOC', config).monthlyPayment;
              parts = [];
              if (rate)
                parts.push(
                  `Rate: <strong>${rate.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
              if (apr)
                parts.push(
                  `APR: <strong>${apr.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
            } else {
              let rate = productTwentyYear?.rate || productThirtyYear.rate;
              let apr = productTwentyYear?.apr || productThirtyYear.apr;
              const config = {
                lineAmount: totalLoanAmount,
                annualRate: rate,
                drawAmount: totalLoanAmount,
                termYears: Number(year.value),
              };
              monthlyValue = calculateLoanProduct('FIXED_HELOC', config).monthlyPayment;
              parts = [];
              if (rate)
                parts.push(
                  `Rate: <strong>${rate.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
              if (apr)
                parts.push(
                  `APR: <strong>${apr.toLocaleString(undefined, {minimumFractionDigits: 3, maximumFractionDigits: 3})}%</strong>`
                );
            }
            const paymentEl = card.querySelector(`[data-term="${year.value}"][data-field="monthly-payment"]`);
            if (paymentEl) {
              paymentEl.textContent =
                monthlyValue && monthlyValue > 0
                  ? `$${monthlyValue.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`
                  : '-';
            }
            const subtextEl = card.querySelector(`[data-value="${year.value}"][data-field="subtext"]`);
            if (subtextEl) {
              subtextEl.innerHTML = parts.length ? parts.join(' | ') : 'Details not available';
            }
          });

          const dataDrawn = drawWrapper.querySelector('.min-draw-amount');

          if (dataDrawn) {
            dataDrawn.textContent = `$${totalLoanAmount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
          }
        }
      });
    } else {
      noResults.classList.remove('d-none');
      cards.forEach(card => {
        card.classList.add('d-none');
      });
    }
  }

  function calculateMortgage(principal, annualRate, termYears) {
    const monthlyRate = annualRate / 100 / 12;
    const n = termYears * 12;

    if (monthlyRate === 0) {
      return principal / n; // 0% interest edge case
    }

    const numerator = monthlyRate * Math.pow(1 + monthlyRate, n);
    const denominator = Math.pow(1 + monthlyRate, n) - 1;

    return principal * (numerator / denominator);
  }

  /**
   * VARIABLE_HELOC – interest-only payment with min/max draw.
   */
  function calculateVariableHELOC(lineAmount, drawAmount, annualRate) {
    const MIN_DRAW = 25000;

    let appliedDraw = drawAmount;

    if (appliedDraw < MIN_DRAW) {
      appliedDraw = MIN_DRAW;
    } else if (appliedDraw > lineAmount) {
      appliedDraw = lineAmount;
    }

    const monthlyRate = annualRate / 100 / 12;
    const payment = appliedDraw * monthlyRate;

    let note = '';
    if (drawAmount < MIN_DRAW) note = `Draw amount increased to minimum of $${MIN_DRAW}.`;
    if (drawAmount > lineAmount) note = `Draw amount reduced to maximum line amount of $${lineAmount}.`;

    return {
      payment,
      appliedDraw,
      note,
    };
  }

  /**
   * FIXED_HELOC – amortizing payment with min/max draw.
   */
  function calculateFixedHELOC(lineAmount, drawAmount, annualRate, termYears) {
    const MIN_DRAW = 25000;

    let appliedDraw = drawAmount;

    if (appliedDraw < MIN_DRAW) {
      appliedDraw = MIN_DRAW;
    } else if (appliedDraw > lineAmount) {
      appliedDraw = lineAmount;
    }

    const monthlyRate = annualRate / 100 / 12;
    const n = termYears * 12;

    let payment;
    if (monthlyRate === 0) {
      payment = appliedDraw / n; // 0% interest edge case
    } else {
      const numerator = monthlyRate * Math.pow(1 + monthlyRate, n);
      const denominator = Math.pow(1 + monthlyRate, n) - 1;
      payment = appliedDraw * (numerator / denominator);
    }

    let note = '';
    if (drawAmount < MIN_DRAW) note = `Draw amount increased to minimum of $${MIN_DRAW}.`;
    if (drawAmount > lineAmount) note = `Draw amount reduced to maximum line amount of $${lineAmount}.`;

    return {
      payment,
      appliedDraw,
      note,
    };
  }

  // --- Unified router ---------------------------------------------------

  /**
   * Unified loan/HELOC calculator.
   *
   * @param {"HELOAN"|"VARIABLE_HELOC"|"FIXED_HELOC"} type
   * @param {object} config
   *   For HELOAN:
   *     - principal  (number)
   *     - annualRate (number, %)
   *     - termYears  (number)
   *
   *   For VARIABLE_HELOC:
   *     - lineAmount (number)
   *     - drawAmount (number)
   *     - annualRate (number, %)
   *
   *   For FIXED_HELOC:
   *     - lineAmount (number)
   *     - drawAmount (number)
   *     - annualRate (number, %)
   *     - termYears  (number)
   *
   * @returns {object} Standardized result:
   *   {
   *     type,                // product type string
   *     monthlyPayment,      // numeric monthly payment
   *     details: { ... }     // product-specific details
   *   }
   */
  function calculateLoanProduct(type, config) {
    switch (type) {
      case 'HELOAN': {
        const {principal, annualRate, termYears} = config;
        const payment = calculateMortgage(principal, annualRate, termYears);

        return {
          type,
          monthlyPayment: payment,
          details: {
            principal,
            annualRate,
            termYears,
          },
        };
      }

      case 'VARIABLE_HELOC': {
        const {lineAmount, drawAmount, annualRate} = config;
        const result = calculateVariableHELOC(lineAmount, drawAmount, annualRate);

        return {
          type,
          monthlyPayment: result.payment,
          details: {
            lineAmount,
            requestedDraw: drawAmount,
            appliedDraw: result.appliedDraw,
            annualRate,
            note: result.note,
          },
        };
      }

      case 'FIXED_HELOC': {
        const {lineAmount, drawAmount, annualRate, termYears} = config;
        const result = calculateFixedHELOC(lineAmount, drawAmount, annualRate, termYears);

        return {
          type,
          monthlyPayment: result.payment,
          details: {
            lineAmount,
            requestedDraw: drawAmount,
            appliedDraw: result.appliedDraw,
            annualRate,
            termYears,
            note: result.note,
          },
        };
      }

      default:
        throw new Error(`Unsupported product type: ${type}`);
    }
  }

  function updateContactCard(data) {
    const card = widget.querySelector('.widget-card_contacts');
    if (!card) return;

    const mappingsJson = card.getAttribute('data-mappings');
    if (!mappingsJson) return;

    let mappings;
    try {
      mappings = JSON.parse(mappingsJson);
    } catch {
      console.error('Invalid mappings JSON');
      return;
    }
    const getValue = alias => {
      const map = mappings.find(m => m.alias === alias);
      if (!map) return '';
      if (map.staticValue) return map.staticValue;
      if (map.value) {
        const selector = `
                input[name="${map.value}"],
                select[name="${map.value}"],
                textarea[name="${map.value}"]
            `;
        const fields = form.querySelectorAll(selector);
        if (!fields.length) return '';

        const first = fields[0];

        if (first.type === 'radio') {
          const checked = [...fields].find(f => f.checked);
          return checked ? checked.value : '';
        }

        if (first.type === 'checkbox') {
          const checkedValues = [...fields].filter(f => f.checked).map(f => f.value);
          return checkedValues.join(', ');
        }

        return first.value || '';
      }

      return '';
    };
    widget.querySelectorAll('dd[data-field]').forEach(dd => {
      const template = dd.getAttribute('data-field');

      const output = template.replace(/{{(.*?)}}/g, (_, alias) => {
        return getValue(alias.trim()) || '';
      });

      dd.textContent = (template == '{{property_value}}' ? '$' : '') + output || '-';
    });

    if (data.request) {
      const first = parseFloat(data.request.firstMortgageBalance) || 0;
      const creditScore = parseFloat(data.request.creditScore) || 0;

      const dd = widget.querySelector('dd[data-field="{{loanAmount}}"]');
      const creditScoreDd = widget.querySelector('dd[data-field="{{creditScore}}"]');

      if (first > 0) {
        dd.textContent = `$${first.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
      } else {
        dd.textContent = '-';
      }

      if (creditScore) {
        const input = widget.querySelector(`input[type="radio"][value="${creditScore}"]`);
        const label = widget.querySelector(`label[for="${input?.id}"]`);

        if (input && label) {
          creditScoreDd.textContent = label.textContent.trim();
        } else {
          creditScoreDd.textContent = '-';
        }
      }
    }
  }

  function initiateLastPageListeners() {
    const years = form.querySelectorAll(
      '[data-scenario="HELOAN"] [data-field="term-list"] input[type="radio"]'
    );
    years.forEach(year => {
      year.addEventListener('change', e => {
        const widgetCardInfo = year.closest('.widget-card_info');
        const paymentLabels = widgetCardInfo.querySelectorAll('data[data-value], [data-field="subtext"]');
        paymentLabels.forEach(lbl => lbl.classList.add('d-none'));
        const selected = widgetCardInfo.querySelectorAll(
          `data[data-value="${e.target.value}"], [data-value="${e.target.value}"][data-field="subtext"]`
        );
        if (selected) {
          selected.forEach(lbl => lbl.classList.remove('d-none'));
        }
      });
    });

    const fixedAndVariableHelocInputs = form.querySelectorAll(
      '[data-scenario="FIXED_HELOC"] .card-list-group input[type="radio"], [data-scenario="VARIABLE_HELOC"] .card-list-group input[type="radio"]'
    );
    fixedAndVariableHelocInputs.forEach(input => {
      input.addEventListener('change', e => {
        const widgetCardInfo = input.closest('.widget-card_info');
        const termValue =
          widgetCardInfo.querySelector('[data-field="term-list"] input:checked')?.value || '10';
        const paymentLabels = widgetCardInfo.querySelectorAll(
          'data[data-field], data[data-value], [data-field="subtext"]'
        );
        paymentLabels.forEach(lbl => lbl.classList.add('d-none'));
        const selected = widgetCardInfo.querySelectorAll(
          `data[data-term="${termValue}"], [data-value="${termValue}"][data-field="subtext"]`
        );
        if (selected) {
          selected.forEach(lbl => lbl.classList.remove('d-none'));
        }
      });
    });

    let debounceTimer;

    if (sliderEl) {
      sliderEl.noUiSlider.on('set', function (values, handle) {
        if (suppressSetEvent) return;
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(async () => {
          showLoading();
          hideWidgetError();
          const data = await fetchData();
          updateLoanCards(JSON.parse(data.result));
          hideLoading();
        }, 300);
      });
    }
  }

  initiateLastPageListeners();
  initStickyPosition(widget);
  prefillForm();
};

function initStickyPosition(widget) {
  const wrapper = widget.closest('.hero-media.js-position-sticky');
  if (!wrapper) return;

  const pageHeader = document.querySelector('.page-header');
  const sectionWithOffset = document.querySelector('.widget-wrapper.with-form-offset');
  const stopSection = sectionWithOffset?.nextElementSibling || document.querySelector('.page-footer');

  let ticking = false;
  let paddingBottom = calcPadding();

  function calcPadding() {
    return sectionWithOffset ? parseFloat(getComputedStyle(sectionWithOffset).paddingBottom) : 60;
  }

  function update() {
    if (isMatchMedia('xl-down')) {
      wrapper.classList.remove('position-fixed', 'position-absolute');
      wrapper.style.top = '';
      ticking = false;
      return;
    }

    const headerHeight = pageHeader?.offsetHeight || 0;
    const scrollY = window.scrollY;
    const stopTop = stopSection
      ? stopSection.getBoundingClientRect().top + scrollY
      : document.body.scrollHeight;
    const stopScroll = stopTop - wrapper.offsetHeight - paddingBottom * 2;
    const stopped = scrollY >= stopScroll;

    wrapper.classList.toggle('position-fixed', !stopped);
    wrapper.classList.toggle('position-absolute', stopped);
    wrapper.style.top = stopped
      ? `${Math.round(stopScroll)}px`
      : `calc(${Math.round(headerHeight)}px + var(--bs-widget-hero-padding-y))`;

    ticking = false;
  }

  function onScrollOrResize() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  update();
  window.addEventListener('scroll', onScrollOrResize, {passive: true});
  window.addEventListener(
    'resize',
    () => {
      paddingBottom = calcPadding();
      onScrollOrResize();
    },
    {passive: true}
  );
}
